import SelectAbstract from 'components/SelectAbstract';
import PropTypes from 'prop-types';

import { ReactComponent as ArrowIcon } from 'icons/components/arrowSelect.svg';

import './index.less';
import './themes/default.less';

export default class DropDown extends SelectAbstract {
    static propTypes = {
        ...SelectAbstract.propTypes,
        type: PropTypes.oneOf(['primary', 'secondary']),
    };
    static defaultProps = {
        ...SelectAbstract.defaultProps,
        type: "primary",
    };

    get mainClassName() {
        return "dropDown";
    }

    getMainStyle() {
        return `${this.mainClassName} ${this.props.type}`;
    }
    
    getPopupItemStyle(it, i) {
        return this.state.index === i ? "active" : "";
    }

    getRightIcon(opened) {
        const openState = opened ? "rotate180" : "";

        return <ArrowIcon className={`arrowIcon transit025 ${openState}`} />;
    }
}

